"use strict";

var validMoment = require('../helpers/is-valid-moment-object');

module.exports = function (value, dateFormat) {
  if (!validMoment(value)) return value;
  return value.format(dateFormat);
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2-premium/compiled/filters/format-date.js
// module id = 872
// module chunks = 0